// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__h37TL","col":"styles_col__2gWua"};